export default __webpack_public_path__ + "static/media/curry.51bcc530.PNG";